import { PayloadAction } from '@reduxjs/toolkit'
import {
    createNewPageData,
    generateTempUUID,
    StudioState,
} from '../initialState'

export const pageReducers = {
    pageAdded: (state: StudioState) => {
        const newPageId = generateTempUUID()
        const newPage = createNewPageData(
            newPageId,
            `Page ${state.pageIds.length + 1}`,
        )
        state.pages[newPageId] = newPage
        state.pageIds.push(newPageId)
        state.activePageId = newPageId
    },
    pageSwitched: (
        state: StudioState,
        action: PayloadAction<{ pageId: string }>,
    ) => {
        const { pageId } = action.payload
        if (state.pages[pageId]) {
            state.activePageId = pageId
        }
    },
    pageDeleted: (state: StudioState, action: PayloadAction<{ pageId: string }>) => {
        if (state.pageIds.length <= 1) {
            return
        }

        const { pageId } = action.payload
        const pageIndex = state.pageIds.indexOf(pageId)

        if (pageIndex > -1) {
            delete state.pages[pageId]
            state.pageIds.splice(pageIndex, 1)

            if (state.activePageId === pageId) {
                const newActiveIndex = Math.max(0, pageIndex - 1)
                state.activePageId = state.pageIds[newActiveIndex]
            }
        }
    },
}
